export const DropArea = {
  mounted() {
    function showOverlay(_) {
      dropOverlay.classList.add("opacity-100");
      dropOverlay.classList.remove("opacity-0");
    }

    function hideOverlay(_) {
      dropOverlay.classList.add("opacity-0");
      dropOverlay.classList.remove("opacity-100");
    }

    const dropArea = this.el;
    const dropOverlay = dropArea.querySelector(`#${dropArea.dataset.dropOverlay}`);

    ["dragover", "dragenter"].forEach((eventName) => {
      dropArea.addEventListener(eventName, (event) => {
        showOverlay(event);
      });
    });

    ["dragleave", "drop"].forEach((eventName) => {
      dropArea.addEventListener(eventName, (event) => {
        hideOverlay(event);
      });
    });

    this.cleanup = () => {
      ["dragover", "dragenter"].forEach((eventName) => {
        dropArea.removeEventListener(eventName, showOverlay);
      });

      ["dragleave", "drop"].forEach((eventName) => {
        dropArea.removeEventListener(eventName, hideOverlay);
      });
    };
  },

  destroyed() {
    this.cleanup?.();
  },
};
